exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lpForm[data-v-6824002c]{max-width:500px;margin:0 auto;padding:40px 30px 0}.lpForm__title[data-v-6824002c]{text-align:center;font-weight:700;font-size:24px;line-height:1;color:#32373f;margin:0 -10px 40px}.lpForm__submit[data-v-6824002c]{background:#412e2e;border:2px solid #412e2e;border-radius:35px;padding:15px;font-weight:700;font-size:14px;line-height:21px;color:#fff;text-align:center;margin:40px auto 0;-webkit-transition:.2s;transition:.2s;cursor:pointer}.lpForm__submit[disabled][data-v-6824002c]{color:#dcdfe2;background:#fff;border-color:#dcdfe2;pointer-events:none;cursor:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6824002c","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/YearLuck/y2022/lpForm.vue
// module id = 2UQx
// module chunks = 0